import Button from '@mui/material/Button';
import ListSubheader from '@mui/material/ListSubheader';
import MenuItem from '@mui/material/MenuItem';
import type { FunctionComponent, MouseEventHandler, ReactNode } from 'react';
import { Fragment, useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';

type SeeMoreProps = {
    readonly onClick: MouseEventHandler;
};

const SeeMore: FunctionComponent<SeeMoreProps> = ({ onClick }) => {
    const { translate } = useContext(ApplicationContext);

    return (
        <MenuItem onClick={onClick}>
            <Button sx={{ padding: 0 }}>{translate('globalsearch.see-more')}</Button>
        </MenuItem>
    );
};

type DropdownSectionProps = {
    readonly children: ReactNode;
    readonly hasMore: boolean;
    readonly label: string;
    readonly onClick: MouseEventHandler;
};

export const DropdownSection: FunctionComponent<DropdownSectionProps> = ({ children, hasMore, label, onClick }) => (
    <Fragment>
        <ListSubheader key={label} disableSticky={true}>
            {label}
        </ListSubheader>
        {children}
        {hasMore && <SeeMore onClick={onClick} />}
    </Fragment>
);
